import { getSearchResultAction } from "../../../Actions/LogicActions/Search/GetSearchResultAction";
import { BaseAction } from "../../../core/actions/BaseAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { TrainOfferDateSelector } from "../../../Orchestrator/Types/Index";
import dayjs from "dayjs";

export class DateSelectorChangeAction extends BaseAction<void, TrainOfferDateSelector> {

    override async run(): Promise<void | null> {
        let result: any;
        try {
            const { date, fullDate, currentTrainType, search } = this.params!;

            if (currentTrainType === TrainTypeEnum.outbound) {
                updateRecoilState("searchStateAtom", {
                    ...search,
                    outboundDate: dayjs(new Date(fullDate).toISOString())
                });
            } else {
                updateRecoilState("searchStateAtom", {
                    ...search,
                    inboundDate: dayjs(new Date(fullDate).toISOString())
                })
            }

            const formattedDate = dayjs(fullDate).startOf('day').format("YYYY-MM-DDTHH:mm:ss");
            const arrivalDate = ((currentTrainType === TrainTypeEnum.outbound ? search?.inboundDate : search.outboundDate)?.toISOString() || null)
            const arrivalDateString = arrivalDate ? dayjs(arrivalDate).startOf('day').format("YYYY-MM-DDTHH:mm:ss") : null;

            getSearchResultAction.setParams({
                departureTime: formattedDate,
                arrivalTime: arrivalDateString ? arrivalDateString : undefined,
                origin: currentTrainType === TrainTypeEnum.outbound ? search.from : search.to,
                destination: currentTrainType === TrainTypeEnum.outbound ? search.to : search.from,
                totalPassengerCount: Object.keys(search.passengers || {}).length,
                passengerCounts: search.passengers || {},
                trainType: currentTrainType,
                fromShuttle: search.fromShuttle,
                toShuttle: search.toShuttle,
            })
            await getSearchResultAction.execute();
            if (getSearchResultAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                result = getSearchResultAction.result?.data;
            }

        } catch (error) {
            console.error("Error in DateSelectorChangeAction:", error);
        } finally {
            return result;
        }
    }
}

// Create a singleton instance
export const dateSelectorChangeAction = new DateSelectorChangeAction(); 